import React, { useContext, useEffect, useState } from "react";
import "./MobileCategory.css";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faXmark } from "@fortawesome/free-solid-svg-icons";
import MobileBestSeller from "./MobileCatefories/MobileAccessories";
import { ThemeContext } from "../../Contexts/ThemeContext";
import MobileNails from "./MobileCatefories/MobileNails";
import Makeup from "../NavCategories/Makeup";
import Skincare from "../NavCategories/Skincare";
import Haircare from "../NavCategories/Haircare";
import PersonalCare from "../NavCategories/PersonalCare";

const MobileCategory = ({ menu, handleMenu }) => {
  const { setCategory } = useContext(ThemeContext);
  const location = useLocation();
  const [showBackIcon, setShowBackIcon] = useState(false);

  const showIcon = () => {
    setShowBackIcon(true);
  };

  useEffect(() => {
    handleMenu(false);
  }, [location.pathname]);

  const openPdfLink = () => {
    const pdfUrl =
      "https://pdfhost.io/v/KB~v4P1ZS_Global_Merchandising_Catalogue19082024bd";
    window.open(pdfUrl, "_blank"); // Opens the URL in a new tab/window
  };

  return (
    <div
      className={`mobile-category-container ${
        menu ? "" : "mobile-category-container-left"
      }`}
    >
      {/*------------------------------------- All Navigation Category  ------------------------------------*/}
      {showBackIcon && (
        <FontAwesomeIcon
          onClick={() => setShowBackIcon(false)}
          icon={faArrowLeft}
          // onClick={() => handleMenu(false)}
          className={`inline mr-auto w-[24px] h-[24px] m-4 text-accent`}
        />
      )}

      <FontAwesomeIcon
        icon={faXmark}
        onClick={() => handleMenu(false)}
        className={` absolute right-0 ml-auto w-[24px] h-[24px] m-4 text-accent`}
      />
      <div className="mobile-category mt-16">
        <Makeup showIcon={showIcon} />
        <Skincare showIcon={showIcon} />
        <Haircare showIcon={showIcon} />
        <PersonalCare showIcon={showIcon} />

        <Link to="/wholesale" className={`mr-10 mt-3 block font-bold `}>
          WHOLESALE
        </Link>
        <br />
      </div>
    </div>
  );
};

export default MobileCategory;
